import { render, staticRenderFns } from "./CreateTicket.vue?vue&type=template&id=59fba9f2"
import script from "./CreateTicket.vue?vue&type=script&lang=js"
export * from "./CreateTicket.vue?vue&type=script&lang=js"
import style0 from "./CreateTicket.vue?vue&type=style&index=0&id=59fba9f2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports